export const validateCPF = (cpf = "") => {
    const cleaned = cpf.replace(/\D/g, "")
    if (cleaned.length !== 11 || /^(\d)\1+$/.test(cleaned)) return false

    const calcDigit = (base) => {
        let sum = 0
        for (let i = 0; i < base.length; i += 1) {
            sum += parseInt(base[i], 10) * (base.length + 1 - i)
        }
        const mod = sum % 11
        return mod < 2 ? 0 : 11 - mod
    }

    const base = cleaned.slice(0, 9)
    const d1 = calcDigit(base)
    const d2 = calcDigit(base + d1)
    return cleaned === base + d1.toString() + d2.toString()
}

export const validateCNPJ = (cnpj = "") => {
    const cleaned = cnpj.replace(/\D/g, "")
    if (cleaned.length !== 14 || /^(\d)\1+$/.test(cleaned)) return false

    const calcDigit = (base) => {
        const weights = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
        let sum = 0
        for (let i = 0; i < base.length; i += 1) {
            sum += parseInt(base[i], 10) * weights[i + (weights.length - base.length)]
        }
        const mod = sum % 11
        return mod < 2 ? 0 : 11 - mod
    }

    const base = cleaned.slice(0, 12)
    const d1 = calcDigit(base)
    const d2 = calcDigit(base + d1)
    return cleaned === base + d1.toString() + d2.toString()
}

export const validateCpfCnpj = (value = "") => {
    const digits = value.replace(/\D/g, "")
    if (digits.length <= 11) return validateCPF(digits)
    return validateCNPJ(digits)
}
